import { createAction, props } from '@ngrx/store';
import { StatisticsItem } from '../models/statistics-item';
import { NewsItem } from '../models/news-item';
import { HomePageDataDTO } from 'src/app/web-api-client';

export const loadHomeStores = createAction('[HomeStore] Load HomeStores');

export const loadStatisticsData = createAction('[HomeStore] Load Statistics Data', props<{ statisticsData: StatisticsItem[] }>());

export const loadNews = createAction('[HomeStore] Load News', props<{ count?: number }>());

export const  loadNewsSuccess = createAction('[HomeStore] Load News Success', props<{ news: NewsItem[] }>());

export const updateHomePageStatistics = createAction('[HomeStore] Load Home Page Statistics', 
props<{ statisticsData: HomePageDataDTO[] }>());

export const setSelectedNewsId = createAction('[HomeStore] Select News Id', props<{ id: number }>());

export const cleanupSelectedNewsId = createAction('[HomeStore] Cleanup Selected News Id');
